import { useMutation } from "@apollo/react-hooks";
import { Modal } from "@shopify/polaris";
import React, { useCallback } from "react";
import { ACCEPT_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import { useAmazonIdeaCtx } from "../context";

export default function AcceptAmazonIdea({ open, onClose, ids }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();

    const [setDelay] = useTimeout();
    // const [markDone, { loading }] = useMutation(MARK_AMAZON_IDEA_DONE, {
    const [markDone, { loading }] = useMutation(ACCEPT_AMAZON_IDEA, {
        onCompleted: () => {
            setNotify({
                msg: "Accept amazon idea Done successfully",
                err: false,
            });

            onClose();
            setDelay(() => {
                refetch && refetch();
            }, 1500);
        },
        onError: (err) => {
            setNotify({ msg: handleError(err?.toString()), err: true });
        },
    });

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        toggleToast && toggleToast(true);
        setNotify && setNotify({ msg: null, err: false });

        markDone({
            variables: {
                ids,
            },
        });
    }, [ids, markDone, toggleToast, setNotify]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Accept Amazon Idea"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            <p>Are you sure to accept this Idea?</p>
        </Modal>
    );
}
